/**
 * The revenue policy route table (FIN-FR-034, FSD Part 2 s-2.1 catalogue, follow-up #70).
 *
 * Exported as `REVPOLICY_ROUTES`; INT imports and spreads it in `web/src/router/index.ts` and
 * adds the nav item (id `revenue-policy`, section s-2.1, code FIN-FR-034). One route: the policy
 * in force, its open draft, the version history and the departures report are sections of one
 * screen, so the nav item covers everything this module routes.
 *
 * The server declares every revpolicy route under the general-ledger entitlement (`gl`); the
 * route meta has no entitlement key, so the server's refusal is the gate for an unentitled plan.
 */

import type { RouteRecordRaw } from 'vue-router'

import { REVPOLICY_PERMISSIONS } from '@/modules/revpolicy/permissions'

export const REVPOLICY_NAV = {
  id: 'revenue-policy',
  section: 's-2.1',
  code: 'FIN-FR-034',
  labelKey: 'revpolicy.nav.label',
  descriptionKey: 'revpolicy.nav.description',
  to: '/finance/revenue-policy',
  permission: REVPOLICY_PERMISSIONS.read,
} as const

export const REVPOLICY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/finance/revenue-policy',
    name: 'revenue-policy',
    component: () => import('@/modules/revpolicy/RevenuePolicyView.vue'),
    meta: { titleKey: 'revpolicy.routeTitles.policy', permission: REVPOLICY_PERMISSIONS.read },
  },
]
